(() => {
  const selector = '[data-qha-shipping-progress]';
  let timer;
  let pending = false;
  let rerun = false;
  let requestVersion = 0;
  const update = cart => {
    if (!cart || !Number.isFinite(cart.total_price)) return;
    document.querySelectorAll(selector).forEach(bar => {
      const message = bar.querySelector('[data-qha-shipping-message]');
      if (!message || bar.dataset.country !== 'CA' || bar.dataset.currency !== 'CAD') return;
      if (cart.currency && cart.currency !== bar.dataset.currency) return;
      const threshold = Number(bar.dataset.threshold);
      if (!(threshold > 0)) return;
      const remaining = Math.max(0, threshold - cart.total_price);
      const percentage = Math.min(100, Math.max(0, cart.total_price / threshold * 100));
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency',currency:'CAD',currencyDisplay:'code'}).format(remaining / 100);
      const text = remaining > 0 ? bar.dataset.pending.replace('__AMOUNT__', amount) : bar.dataset.success;
      if (message.textContent !== text) message.textContent = text;
      bar.querySelector('[data-qha-shipping-fill]').style.width = percentage + '%';
      bar.querySelector('[data-qha-shipping-track]').setAttribute('aria-valuenow', String(Math.round(percentage)));
      bar.dataset.complete = String(remaining === 0);
    });
  };
  const refresh = async () => {
    if (!document.querySelector(selector)) return;
    if (pending) { rerun = true; return; }
    pending = true;
    const version = ++requestVersion;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if (response.ok) {
        const cart = await response.json();
        if (version === requestVersion) update(cart);
      }
    } catch {} finally {
      pending = false;
      if (rerun) { rerun = false; schedule(); }
    }
  };
  const schedule = () => { clearTimeout(timer); timer = setTimeout(refresh, 180); };
  document.addEventListener('cart:updated', event => {
    const cart = event.detail?.cart;
    if (cart) { ++requestVersion; update(cart); } else schedule();
  });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (!target || target.closest(selector)) return false;
      if (target.closest('.quick-cart, [data-section-type="cart"], [data-header-cart]')) return true;
      return [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector)));
    });
    if (relevant) schedule();
  });
  observer.observe(document.body, {subtree:true,childList:true,characterData:true});
  schedule();
})();